import React from 'react';
import TextLink from './../../TextLink';

var ErrorPageAction = function ErrorPageAction(_ref) {
  var action = _ref.action,
      text = _ref.text;
  var actionLink = /*#__PURE__*/React.createElement(TextLink, null, text);

  if (action && typeof action === 'string') {
    actionLink = /*#__PURE__*/React.createElement(TextLink, {
      href: action
    }, text);
  } else if (action && typeof action === 'object') {
    actionLink = action;
  }

  return actionLink;
};

export default ErrorPageAction;